export const pro_camera_inventories = {
  path: "pro-camera/inventories",
  savePath: "pro-camera/inventories",
  fields: {
    id: null,
    serial_number: "",
    camera_status: "pending",
    camera_id: null,
  },
  getFormData: (state) => ({
    id: state.selectedProCameraInventory.id,
    serial_number: state.selectedProCameraInventory.serial_number,
    status: state.selectedProCameraInventory.camera_status,
  }),
  getFetchParams: (state) => ({
    ...(state.filters.status ? { status: state.filters.status } : {}),
    sort_by: state.proCameraSort.by,
    sort_order: state.proCameraSort.order,
  }),
  saveCallBack: (_response, _state, dispatch) => {
    dispatch("fetchList");
  },
  validate: (state) => {
    return state.selectedProCameraInventory && state.selectedProCameraInventory.serial_number !== "";
  },
  reset: (commit) => {
    commit("SET_SELECTED_PRO_CAMERA_INVENTORY", {
      id: null,
      serial_number: "",
      camera_status: "pending",
      camera_id: null,
    });
  },
};
